<template>
  <NavDrawer />

  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title><v-icon>mdi-filter</v-icon> Find Spaces</v-card-title>
          
          <v-card-item><v-text-field v-model="filters.cemeteryname" label="Cemetery Name" /></v-card-item>
          <v-container>
            <v-row>
              <v-col cols="12" md="4"><v-text-field v-model="filters.city" label="City" /></v-col>
              <v-col cols="12" md="4"><v-text-field v-model="filters.state" label="State" /></v-col>
              <v-col cols="12" md="4"><v-text-field v-model="filters.county" label="County" /></v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-h5">Available Spaces</v-col>
      <MarketItem v-for="item in filtereditems" :key="item.id" :item="item" />
    </v-row>
    <v-row>
      <v-col v-if="checkForFilter()" cols="12" class="texth-6">No Results Match!</v-col>
    </v-row>
  </v-container>

</template>

<script>
import { defineComponent } from 'vue';

// Components
import NavDrawer from '../components/NavDrawer.vue';
import MarketItem from '../components/MarketItem.vue';

export default defineComponent({
  name: 'HomeView',

  components: {
    NavDrawer,
    MarketItem,
  },

  created : function(){
    this.pageView();
    this.refreshView();
  },

  data: () => ({
    drawer : false,
    items : [],
    filtereditems : [],
    filters : {
      cemeteryname : "",
      city : "",
      state : "",
      county : ""
    },
    page : 0,
  }),

  methods:{
    pageView(){
      fetch("https://app.cemeterycommunity.com:11000/api/pageview", { method: "POST", headers : { data : JSON.stringify( { group : 'Marketplace', page : 'Main' } ) } });

      if(this.$route.query.cemeteryname) this.filters.cemeteryname = this.$route.query.cemeteryname;
      if(this.$route.query.city) this.filters.city = this.$route.query.city;
      if(this.$route.query.state) this.filters.state = this.$route.query.state;
      if(this.$route.query.county) this.filters.county = this.$route.query.county;
      if(this.$route.query.page) this.page = this.$route.query.page;
      
    },
    checkForFilter(){
      return ((this.filters.cemeteryname != "" || this.filters.city != "" || this.filters.state != "" || this.filters.county != "") && !this.filtereditems || this.filtereditems.length == 0)
    },
    refreshView(){
      fetch("https://app.cemeterycommunity.com:11000/api/getmarketplaceitems", { method: "POST" })
      .then( res => res.json() )
      .then( res =>  {
        this.items = res.results;

        this.updateFilter();
      });
    },
    updateFilter(){
      let filtereditems = [];

      this.items.forEach(item => {
        if((this.filters.cemeteryname != "" && this.filters.city != "" && this.filters.state != "" && this.filters.county != "")
          && (item.cemeteryname.toLowerCase().includes(this.filters.cemeteryname.toLowerCase()) && item.city.toLowerCase().includes(this.filters.city.toLowerCase()) && item.state.toLowerCase().includes(this.filters.state.toLowerCase()) && item.county.toLowerCase().includes(this.filters.county.toLowerCase()))) filtereditems.push(item);
        else if(this.filters.cemeteryname != "" && item.cemeteryname.toLowerCase().includes(this.filters.cemeteryname.toLowerCase())) filtereditems.push(item);
        else if(this.filters.city != "" && item.city.toLowerCase().includes(this.filters.city.toLowerCase())) filtereditems.push(item);
        else if(this.filters.state != "" && item.state.toLowerCase().includes(this.filters.state.toLowerCase())) filtereditems.push(item);
        else if(this.filters.county != "" && item.county.toLowerCase().includes(this.filters.county.toLowerCase())) filtereditems.push(item);
        else if(this.filters.cemeteryname == "" && this.filters.city == "" && this.filters.state == "" && this.filters.county == "") filtereditems.push(item);
      });

      filtereditems.sort((a,b) => {
        if(a.cemeteryid > -1) return -1
        else if(b.cemeteryid > -1) return 1
        else if(a.premium > 0) return -1
        else if(b.premium > 0) return 1;
        else a.id - b.id 
      });

      this.filtereditems = filtereditems;
    }
  }
});
</script>
